export default {
  getSignerAuths: (state) => state.signerAuths,
  getSignerSignAs: (state) => state.signerSignAs,
  getNewSignerSignAs: (state) => state.newSignerSignAs,
  getCommunicateBy: (state) => state.communicateBy,
  getContacts: (state) => state.contacts,
  getLinks: (state) => state.links,
};
